import { render, staticRenderFns } from "./exchangeRecords.vue?vue&type=template&id=f9758e7e&scoped=true"
import script from "./exchangeRecords.vue?vue&type=script&lang=js"
export * from "./exchangeRecords.vue?vue&type=script&lang=js"
import style0 from "./exchangeRecords.vue?vue&type=style&index=0&id=f9758e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9758e7e",
  null
  
)

export default component.exports